import React from 'react'
import TextField from '@mui/material/TextField'

export default function TextInput(props) {
    return (
        <>
            <div className='div-input'>
                <div className='label-input'>{props.label}</div>
                <TextField type={props.type} name={props.name} value={props.value} onChange={props.onChange} size='small' placeholder={props.placeholder} fullWidth />
            </div>
        </>
    )
}
